"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutImpactReportFilterDTO_1 = require("../model/SelloutImpactReportFilterDTO");

var SelloutImpactReportFilterDTOConverter_1 = require("./SelloutImpactReportFilterDTOConverter");
/**
 * Implementation of {@link SelloutImpactReportFilterDTOConverter}.
 *
 * @author Jan Prokop
 */


var SelloutImpactReportFilterDTOConverterImpl =
/*#__PURE__*/
function (_SelloutImpactReportF) {
  _inherits(SelloutImpactReportFilterDTOConverterImpl, _SelloutImpactReportF);

  function SelloutImpactReportFilterDTOConverterImpl() {
    _classCallCheck(this, SelloutImpactReportFilterDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportFilterDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutImpactReportFilterDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var schema = SelloutImpactReportFilterDTO_1.SelloutImpactReportFilterDTO.schema;
      return SelloutImpactReportFilterDTO_1.SelloutImpactReportFilterDTO.fromDataDict({
        dateFrom: schema.dateFrom.valueOfField(source),
        dateTo: schema.dateTo.valueOfField(source),
        categoryIds: schema.categoryIds.valueOf(source.categoryIds ? conversions.asObjectList(source, 'categoryIds', function (id) {
          return conversions.toClassReferenceId(id);
        }) : null),
        selloutTypes: schema.selloutTypes.valueOfField(source),
        priceZoneId: schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)),
        siteIds: schema.siteIds.valueOf(source.siteIds ? conversions.asObjectList(source, 'siteIds', function (id) {
          return conversions.toClassReferenceId(id);
        }) : null),
        productExternalIds: schema.productExternalIds.valueOfField(source),
        supplierIds: schema.siteIds.valueOf(source.supplierIds ? conversions.asObjectList(source, 'supplierIds', function (id) {
          return conversions.toClassReferenceId(id);
        }) : null),
        repriced: schema.repriced.valueOfField(source)
      });
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        categoryIds: source.categoryIds ? conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        selloutTypes: source.selloutTypes ? source.selloutTypes.toArray() : null,
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        siteIds: source.siteIds ? conversions.asObjectArray(source, 'siteIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        productExternalIds: source.productExternalIds ? source.productExternalIds.toArray() : null,
        supplierIds: source.supplierIds ? source.supplierIds.toArray() : null,
        repriced: source.repriced ? source.repriced.toArray() : null
      };
    }
  }]);

  return SelloutImpactReportFilterDTOConverterImpl;
}(SelloutImpactReportFilterDTOConverter_1.SelloutImpactReportFilterDTOConverter);

exports.SelloutImpactReportFilterDTOConverterImpl = SelloutImpactReportFilterDTOConverterImpl;